<template>
    <div class="container my-4" id="work">
        <div class="card1 bg-site-gradient1 head_info p-4 mb-4 border-0 rounded-4 w-100 text-start">
            <div class="card-body p-1 d-flex align-items-center">
                <i class="fab fa-youtube fa-3x rounded-circle text-danger me-3"></i>
                <h4 class="fw-bold">{{ TR.tv_page_title }}</h4>
            </div>
        </div>

        <div v-if="search_text != ''" class="card1 p-4 mb-4 border-0 rounded-4 bg-site-gradient1 w-100 text-start head_info">
            <div class="card-body p-1 d-flex flex-column flex-sm-row align-items-center">
                <div class="me-3">
                    <i class="fa fa-search fs-3"></i>
                </div>
                <div>
                    {{ TR.search_text }}: <b>{{ search_text }}</b>
                    <br>
                    {{ TR.msg_search_result }}: <b>{{ totalrecords }}</b>
                </div>
            </div>
        </div>

        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 mb-3">
            <div class="col card-block" v-for="(item, index) in tv" :key="index">
                <a class="card h-100 work-card rounded-4 text-decoration-none text-dark" :href="item.link" target="_blank">
                    <div class="card-img-top position-relative" :style="`background: url(${item.image || item.youtube_image}) no-repeat left center; background-size: cover;`"></div>
                    <div class="text-secondary small mt-2 px-3">{{ G.dateToStr(item.video_date, 'news_date', 'datetime') }}</div>
                    <div class="card-body">
                        <div class="card-title fw-semibold">{{ item.translate[0]?.title }}</div>
                        <div class="card-description fs-7" v-html="item.translate[0]?.description"></div>
                    </div>
                </a>
            </div>
        </div>

        <Pagination
            v-if="tv.length"
            :row_count="totalrecords"
            :pages_count="pages_count"
            :lang="TR"
            :current_page="current_page"
            :perpage="perpage"
            :page_row_count="G.rowsPerPageOptions"
            @navigate="pagenav"
            class="pagenav mt-3"
        />
    </div>
</template>


<script>
import { ref, onMounted, watchEffect } from "vue";
import { useRoute, useRouter } from 'vue-router';

import { useStore } from "@/system_modules/store";

import Pagination from '@/components/elements/Pagination.vue';

import { G, ajax } from "@/_common";

export default {
    title: 'TV',
    name: "TvP",
    components: {
        Pagination,
    },
    // props:{
    //     data:{
    //         type: Object,
    //         default: {}
    //     }
    // },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const TR = ref({});
        const tv = ref([]);

        const pages_count = ref(0);
        const current_page = ref(null);
        const perpage = ref(20);
        const totalrecords = ref(0);
        const search_text = ref('');

		// const category_id = ref(0);
		// const author_id = ref(0);
		const route_obj = ref({});
        // const selectedFilters = ref({});
        // const selectedSortField = ref("video_date");
		// const selectedSortOrder = ref(-1);

		const page = route.params && route.params.page ? parseInt(route.params.page) : 1;
		perpage.value = route.params && route.params.perpage ? parseInt(route.params.perpage) : 20;
		// category_id.value = route.params && route.params.category_id ? parseInt(route.params.category_id) : 0;
		// author_id.value = route.params && route.params.author_id ? parseInt(route.params.author_id) : 0;
		search_text.value = route.query && route.params.search_text ? route.params.search_text : '';

        // selectedSortField.value = route.params.sortfield || "video_date";
        // selectedSortOrder.value = parseInt(route.params.sortorder || -1);

        current_page.value = page;

        const pagenav = async (p, pp) => {
            perpage.value = pp;
            // if( search_text.value != '' )
            //     await getTVChannels(p);
            // else
                await getTVChannels(p);

            // router.push({name: 'tv_paging', params: route_obj.value});
            router.push({name: 'tv', params: route_obj.value});
        }

        const getTVChannels = async (first) => {
            if( first === undefined ) first = 1;
            route_obj.value = {
                page: first,
                perpage: perpage.value,
                // category_id: parseInt(category_id.value) || 0,
                // author_id: parseInt(author_id.value) || 0,
                // sortfield: selectedSortField.value,
                // sortorder: selectedSortOrder.value,
                // filters: Object.keys(selectedFilters.value).filter((k) => selectedFilters.value[k] == true).join(',') || '0',
                search_text: search_text.value || '',
			};
        };

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        onMounted(async () => {
            await getTVChannels(page);

            await ajax({
                loading: true,
                // url: store.getTV(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                url: store.getTVPaging(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                success: (e) => {
                    tv.value = e.data.data;
                    totalrecords.value = e.data.total_records;
                    pages_count.value = Math.ceil(e.data.total_records / perpage.value);
                }
            });
        });

        return {
            G,
            TR,
            tv,
            pagenav,
            pages_count,
            totalrecords,
            current_page,
            perpage,
            search_text
        };
    },
};
</script>


<style lang="scss">
.card-block{
    .card {
        border: 1px solid var(--card-border-color);
        transition: box-shadow .3s;
    }

    .card-img-top {
        border-radius: 1rem 1rem 0 0;
        height: 200px;
    }

    .card:hover {
        box-shadow: 0 0 21px rgba(33, 33, 33, .2);
        cursor: pointer;
        scale: 1.01;
    }

    .card a {
        color: rgb(var(--site-primary-color-rgb));
    }

}
.head_info{
    box-shadow: var(--shadow);
}
</style>
